import {NetworkStatus} from '@apollo/client';
import type {IBreadcrumbItem} from 'components/FluentUICompat';
import React, {createContext} from 'react';
import {GetRegulatoryDocumentDetailsQuery} from '../hooks/useGetRegulatoryDocumentDetails.generated';

export interface RegDocInjectedData {
	/**
	 * The pre-fetched data shaped as the regulatoryDocument query result.
	 * When provided, RegDocDetailsPage skips its own query.
	 */
	data: GetRegulatoryDocumentDetailsQuery | undefined;
	isLoading: boolean;
	networkStatus: NetworkStatus;
	/**
	 * When provided, overrides the default breadcrumbs built from the regulation.
	 */
	breadcrumbItems?: IBreadcrumbItem[];
	/**
	 * Getex-specific fields that have no equivalent in RegulatoryDocument.
	 * Present only when injected from GetexAsRegDocDetailsPage.
	 */
	getexExtras?: {
		regulationNumber: string;
		regulationStatus: string;
		vehicleCategories: string[];
		traceKeywords: Array<{id: string; name: string}>;
	};
}

export const RegDocInjectedDataContext =
	createContext<RegDocInjectedData | null>(null);
